import { ElMessageBox } from 'element-plus'
import Swal from "sweetalert2";
import { ElNotification } from 'element-plus'
import { i18n } from './lang/i18n.js'

/** Above catalog insured dialogs (--catalog-z-nested-popper: 3055) and navbar dropdown (3000). */
const ALERT_MESSAGE_Z_INDEX = 3200;

function DateFormat(date) {
    if (!date) return null;

    const d = new Date(date);
    d.setHours(d.getHours() + 4);
    return d;
}

function FormatDateSafe(dateStr) {
    if (!dateStr) return '';
    
    // Проверяем, является ли это строкой "Invalid Date"
    if (typeof dateStr === 'string') {
        if (dateStr === 'Invalid Date' || dateStr === 'Invalid date' || 
            dateStr.toLowerCase().includes('invalid') || 
            dateStr.includes('NaN') || dateStr === 'NaN.NaN.NaN') {
            return '';
        }
    }
    
    // Проверяем, если это объект Date
    if (dateStr instanceof Date) {
        if (isNaN(dateStr.getTime())) {
            return '';
        }
    }
    
    // Проверяем через toString
    try {
        const str = dateStr.toString();
        if (str === 'Invalid Date' || str === 'Invalid date' || 
            str.toLowerCase().includes('invalid') || 
            str.includes('NaN')) {
            return '';
        }
    } catch (e) {
        return '';
    }
    
    return dateStr;
}


let BreadcrumbData = null

function SetBreadcrumb(list) {
    BreadcrumbData = list
}
function GetBreadcrumb() {
    return BreadcrumbData
}



function Print(id) {
    const element = document.getElementById(id)
    if (!element) return

    const printContent = element.innerHTML

    const printWindow = window.open('', '', 'width=2100,height=2970')
    printWindow.document.write(`
      <html>
        <body>${printContent}</body>
      </html>
    `)
    printWindow.document.close()
    // printWindow.focus()
    printWindow.print()
    // printWindow.close()
}

function FormatNumber(value) {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '';
    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
}

function Alert(text) {
    if (unauthorizedRedirectPending) return;

    let message = '';
    if (text == null) {
        message = '';
    } else if (typeof text === 'string') {
        message = text.trim();
    } else {
        message = formatApiErrors(text) || formatApiErrorItem(text);
    }
    // Suppress noisy transport errors in UI popups.
    if (
        !message ||
        message === '[object Object]' ||
        /network error/i.test(message) ||
        /^HTTP\s*401\b/i.test(message)
    ) {
        return;
    }
    ElMessageBox.confirm(
        message,
        'Alert',
        {
            confirmButtonText: 'OK',
            showCancelButton: false,
            type: 'warning',
            center: true,
            zIndex: ALERT_MESSAGE_Z_INDEX,
        }
    )
}

function DeleteDialog(text, title) {
    return Swal.fire({
        title: title || i18n.global.t('confirmDeleteTitle'),
        text: text,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: i18n.global.t('cancel'),
        confirmButtonText: i18n.global.t('accept'),
        width: "min(540px, calc(100vw - 2rem))",
        padding: "1.5rem",
        background: "#0f172a",
        color: "#e2e8f0",
        backdrop: "rgba(2, 6, 14, 0.72)",
        customClass: {
            popup: "swal2-theme-dark",
            title: "swal2-theme-dark__title",
            htmlContainer: "swal2-theme-dark__html",
            confirmButton: "swal2-dark-confirm",
            cancelButton: "swal2-dark-cancel",
        },
        buttonsStyling: false,
    });
}

function DeleteSuccess() {
    ElNotification({ title: 'Success', message: this.$t('successMsg'), type: 'success', })
}

function CheckPrivilege() {
    return Promise.resolve({ data: { data: [true] } });
}

async function GetPrivilege() {
    return true;
}

function formatApiErrorItem(item) {
    if (item == null) return '';
    if (typeof item === 'string') return item.trim();
    if (typeof item === 'number' || typeof item === 'boolean') return String(item);

    if (typeof item === 'object') {
        const keys = ['msgText', 'message', 'errorMessage', 'description', 'title', 'detail', 'msg'];
        for (const key of keys) {
            if (item[key] == null) continue;
            const nested = formatApiErrorItem(item[key]);
            if (nested) return nested;
        }
    }

    const fallback = String(item).trim();
    return fallback === '[object Object]' ? '' : fallback;
}

function formatApiErrors(errors) {
    if (errors == null) return '';
    if (Array.isArray(errors)) {
        return errors.map(formatApiErrorItem).filter(Boolean).join(', ');
    }
    if (typeof errors === 'object') {
        const parts = [];
        for (const key of Object.keys(errors)) {
            const val = errors[key];
            const text = Array.isArray(val)
                ? val.map(formatApiErrorItem).filter(Boolean).join(', ')
                : formatApiErrorItem(val);
            if (text) parts.push(text);
        }
        if (parts.length) return parts.join('; ');
    }
    return formatApiErrorItem(errors);
}

function formatHttpErrorBody(body) {
    if (!body || typeof body !== 'object') return '';
    if (body.errors) {
        const msg = formatApiErrors(body.errors);
        if (msg) return msg;
    }
    if (body.title) {
        const title = formatApiErrorItem(body.title);
        const detail = body.detail ? formatApiErrorItem(body.detail) : '';
        return detail && detail !== title ? `${title}: ${detail}` : title;
    }
    if (body.detail) return formatApiErrorItem(body.detail);
    if (body.message) return formatApiErrorItem(body.message);
    return '';
}

function createRequestCorrelationId() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function hasRequestCorrelationId(value) {
    if (value == null || typeof value !== "object" || Array.isArray(value)) return false;
    const id = value.requestCorrelationId ?? value.RequestCorrelationId;
    return id != null && String(id).trim() !== "";
}

function ensureRequestCorrelationIdPayload(payload) {
    if (hasRequestCorrelationId(payload)) return payload;
    if (payload == null || typeof payload !== "object" || Array.isArray(payload)) {
        return { requestCorrelationId: createRequestCorrelationId() };
    }
    return { ...payload, requestCorrelationId: createRequestCorrelationId() };
}

/** Axios request interceptor — injects requestCorrelationId into JSON POST bodies when missing. */
function applyRequestCorrelationId(config) {
    const method = String(config.method || "get").toLowerCase();
    if (!["post", "put", "patch", "delete"].includes(method)) return config;

    const data = config.data;
    if (data instanceof FormData || data instanceof URLSearchParams) return config;

    if (data == null || data === "") {
        config.data = { requestCorrelationId: createRequestCorrelationId() };
        return config;
    }

    if (typeof data === "string") {
        try {
            config.data = ensureRequestCorrelationIdPayload(JSON.parse(data));
        } catch {
            /* non-JSON body */
        }
        return config;
    }

    if (typeof data === "object") {
        config.data = ensureRequestCorrelationIdPayload(data);
    }
    return config;
}

function FormatErrorWithCorrelationId(error, response = null) {
    const bodies = [response?.data, error?.response?.data].filter(Boolean);
    for (const body of bodies) {
        const msg = formatHttpErrorBody(body);
        if (msg) return msg;
    }

    const status = error?.response?.status;
    const axiosMsg = error?.message;
    const isGenericAxios =
        axiosMsg && /^Request failed with status code \d+$/i.test(axiosMsg);

    if (status === 400) {
        return isGenericAxios
            ? i18n.global.t('catalogRequestBadParams')
            : axiosMsg;
    }
    if (axiosMsg && !isGenericAxios && axiosMsg !== '[object Object]') {
        return axiosMsg;
    }
    if (status) return `HTTP ${status}`;
    return i18n.global.t('error');
}

function CheckAuthAndRedirect() {
    // JWT gate is temporarily disabled to avoid forced redirects
    // while using newsrc dialogs and catalog flows.
    return true;
}

let unauthorizedRedirectPending = false;

/** Silent redirect when JWT expired / HTTP 401 — no alert dialogs. */
function redirectToLoginOnUnauthorized() {
    if (unauthorizedRedirectPending) return;
    unauthorizedRedirectPending = true;
    try {
        window.localStorage.removeItem('jwt');
        window.localStorage.removeItem('user');
    } catch {
        /* ignore */
    }
    const base = (process.env.BASE_URL || '/').replace(/\/?$/, '/');
    const loginPath = `${base}signIn/catalog`.replace(/\/+/g, '/');
    window.location.assign(loginPath);
}

export default {
    Alert,
    DateFormat,
    FormatDateSafe,
    CheckPrivilege,
    FormatNumber,
    GetPrivilege,
    DeleteDialog,
    DeleteSuccess,
    Print,
    SetBreadcrumb,
    GetBreadcrumb,
    CheckAuthAndRedirect,
    redirectToLoginOnUnauthorized,
    FormatErrorWithCorrelationId,
    formatApiErrors,
    createRequestCorrelationId,
    ensureRequestCorrelationIdPayload,
    applyRequestCorrelationId,
}

